const hideThemeChrome = () => {
  if (!document.querySelector(".supercat-hybrid-stat-page")) return;
  document.documentElement.classList.add("supercat-page-live");
  const headerGroup = document.querySelector("#header-group");
  if (headerGroup) headerGroup.style.setProperty("display", "none", "important");
  Array.from(document.body.children).forEach((child) => {
    if (child.tagName === "FOOTER" && !child.closest(".supercat-hybrid-stat-page")) {
      child.style.setProperty("display", "none", "important");
    }
  });
};
hideThemeChrome();
document.addEventListener("DOMContentLoaded", hideThemeChrome);
window.addEventListener("load", hideThemeChrome);

document.querySelectorAll(".gallery-panel").forEach((gallery) => {
  const dots = Array.from(gallery.querySelectorAll(".dot"));
  const thumbs = Array.from(gallery.querySelectorAll(".slot-thumb[data-slide]"));
  const slides = Array.from(gallery.querySelectorAll(".gallery-slide"));
  const stage = gallery.querySelector(".gallery-stage");
  const previousButton = gallery.querySelector(".gallery-prev");
  const nextButton = gallery.querySelector(".gallery-next");
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("active")));
  let touchStartX = null;
  let touchStartY = null;

  const setActiveSlide = (index, scrollThumbnail = false) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle("active", slideIndex === activeIndex));
    dots.forEach((dot) => {
      const isActive = Number(dot.dataset.slide) === activeIndex;
      dot.classList.toggle("active", isActive);
      dot.setAttribute("aria-current", isActive ? "true" : "false");
    });
    thumbs.forEach((thumb) => {
      const isActive = Number(thumb.dataset.slide) === activeIndex;
      thumb.classList.toggle("active", isActive);
      thumb.setAttribute("aria-current", isActive ? "true" : "false");
    });
    if (scrollThumbnail) {
      thumbs[activeIndex]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  };

  [...dots, ...thumbs].forEach((control) => {
    control.addEventListener("click", () => {
      const index = Number(control.dataset.slide);
      if (Number.isNaN(index)) return;
      setActiveSlide(index, true);
    });
  });

  previousButton?.addEventListener("click", () => setActiveSlide(activeIndex - 1, true));
  nextButton?.addEventListener("click", () => setActiveSlide(activeIndex + 1, true));
  stage?.addEventListener("touchstart", (event) => {
    const touch = event.changedTouches[0];
    touchStartX = touch?.clientX ?? null;
    touchStartY = touch?.clientY ?? null;
  }, { passive: true });
  stage?.addEventListener("touchend", (event) => {
    if (touchStartX === null || touchStartY === null) return;
    const touch = event.changedTouches[0];
    const deltaX = (touch?.clientX ?? touchStartX) - touchStartX;
    const deltaY = (touch?.clientY ?? touchStartY) - touchStartY;
    touchStartX = null;
    touchStartY = null;
    if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    setActiveSlide(activeIndex + (deltaX < 0 ? 1 : -1), true);
  }, { passive: true });
  setActiveSlide(activeIndex);
});

document.querySelectorAll("[data-sc-hero-loop]").forEach((video) => {
  const keepPlaying = () => {
    video.autoplay = true;
    video.defaultMuted = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.disablePictureInPicture = true;
    video.removeAttribute("controls");
    video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("disablepictureinpicture", "");
    if (!document.hidden && video.paused) video.play().catch(() => {});
  };
  video.addEventListener("pause", keepPlaying);
  video.addEventListener("loadeddata", keepPlaying);
  video.addEventListener("canplay", keepPlaying);
  window.addEventListener("pageshow", keepPlaying);
  document.addEventListener("visibilitychange", keepPlaying);
  keepPlaying();
});

document.querySelectorAll("[data-social-post-slider]").forEach((slider) => {
  const track = slider.querySelector("[data-social-slider-track]");
  const slides = track
    ? Array.from(track.querySelectorAll("[data-social-slide]")).sort(
        (firstSlide, secondSlide) => Number(firstSlide.dataset.socialOrder) - Number(secondSlide.dataset.socialOrder)
      )
    : [];
  const previousButton = slider.querySelector("[data-social-slider-prev]");
  const nextButton = slider.querySelector("[data-social-slider-next]");
  const dotsWrapper = slider.querySelector("[data-social-slider-dots]");
  if (!track || slides.length === 0) return;

  slides.forEach((slide) => track.append(slide));

  slides.forEach((slide, index) => {
    if (!slide.id) slide.id = `sc-social-post-${index + 1}`;
  });

  const dots = slides.map((_, index) => {
    const dot = document.createElement("button");
    dot.type = "button";
    dot.className = "sc-social-proof__dot";
    dot.setAttribute("aria-label", `Show testimonial ${index + 1} of ${slides.length}`);
    dot.addEventListener("click", () => showSlide(index));
    dotsWrapper?.append(dot);
    return dot;
  });

  let activeIndex = 0;
  const nearestSlideIndex = () => {
    const firstSlideOffset = slides[0].offsetLeft;
    return slides.reduce((nearest, slide, index) => {
      const slideLeft = slide.offsetLeft - firstSlideOffset;
      const nearestLeft = slides[nearest].offsetLeft - firstSlideOffset;
      return Math.abs(slideLeft - track.scrollLeft) < Math.abs(nearestLeft - track.scrollLeft) ? index : nearest;
    }, 0);
  };

  const updateSliderState = () => {
    activeIndex = nearestSlideIndex();
    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle("active", isActive);
      dot.setAttribute("aria-current", isActive ? "true" : "false");
    });
    if (previousButton) previousButton.disabled = activeIndex === 0;
    if (nextButton) nextButton.disabled = activeIndex === slides.length - 1;
  };

  const showSlide = (index) => {
    const nextIndex = Math.max(0, Math.min(slides.length - 1, index));
    const left = slides[nextIndex].offsetLeft - slides[0].offsetLeft;
    track.scrollLeft = Math.max(0, left);
  };

  let touchStartX = null;
  let touchStartY = null;
  let touchStartIndex = 0;

  track.addEventListener("touchstart", (event) => {
    const touch = event.changedTouches[0];
    if (!touch) return;
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    touchStartIndex = activeIndex;
  }, { passive: true });

  track.addEventListener("touchend", (event) => {
    const touch = event.changedTouches[0];
    if (!touch || touchStartX === null || touchStartY === null) return;
    const horizontalDistance = touch.clientX - touchStartX;
    const verticalDistance = touch.clientY - touchStartY;
    touchStartX = null;
    touchStartY = null;

    if (Math.abs(horizontalDistance) < 42 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;
    showSlide(touchStartIndex + (horizontalDistance < 0 ? 1 : -1));
  }, { passive: true });

  previousButton?.addEventListener("click", () => showSlide(activeIndex - 1));
  nextButton?.addEventListener("click", () => showSlide(activeIndex + 1));
  track.addEventListener("scroll", () => window.requestAnimationFrame(updateSliderState), { passive: true });
  window.addEventListener("resize", updateSliderState);
  updateSliderState();
});

const hybridProductSection = document.querySelector(".sc-copy-refresh #order");
const hybridComparisonSection = document.querySelector(".sc-copy-refresh .compare-reference");
if (hybridProductSection && hybridComparisonSection) {
  hybridProductSection.parentNode.insertBefore(hybridComparisonSection, hybridProductSection);
}

const moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
const formatCents = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);

const setProperty = (form, key, value) => {
  const input = form.querySelector(`[data-sc-property="${key}"]`);
  if (input) input.value = value;
};

const selectedOfferCard = (form) => form.querySelector(".offer-card.selected, .offer-card input:checked")?.closest(".offer-card");
const selectedPurchaseType = (form) => form.querySelector('input[name="purchase_option"]:checked')?.value || "subscription";

const updateStickyOffer = (card, isSubscription) => {
  const stickyOffer = document.querySelector(".sticky-cta");
  const heroOffer = document.querySelector("[data-sc-hero-offer]:not([data-sc-static-offer])");
  if (!card) return;
  const price = isSubscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice;
  const boxes = Math.max(1, Number(card.dataset.boxes) || 1);
  const days = boxes * 30;
  const sachets = boxes * 30;
  const dailyPrice = formatCents(Math.round((Number(price) || 0) / days));
  if (stickyOffer) {
    stickyOffer.textContent = "Fix the Hydration Problem Today";
    stickyOffer.dataset.offerBoxes = card.dataset.boxes || "";
    stickyOffer.dataset.offerPurchaseType = isSubscription ? "subscription" : "one-time";
  }
  if (heroOffer) {
    heroOffer.textContent = isSubscription
      ? `${sachets} daily sachets · ${formatCents(price)} every ${days} days · ${dailyPrice}/day`
      : `${sachets} daily sachets · ${formatCents(price)} one time · ${dailyPrice}/day`;
  }
};

const updateOfferForm = (form) => {
  const card = selectedOfferCard(form);
  if (!card) return;

  const isSubscription = selectedPurchaseType(form) === "subscription";
  const sellingPlanInput = form.querySelector("[data-sc-selling-plan]");
  const currentPrice = form.closest(".shopify-product-box")?.querySelector("[data-sc-current-price]");
  const currentCompare = form.closest(".shopify-product-box")?.querySelector("[data-sc-current-compare]");
  const submit = form.querySelector(".product-submit");
  const cardPrice = Number(isSubscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice);
  const compareAt = Number(card.dataset.compareAt);
  const subcopy = isSubscription ? card.dataset.subscriptionSubcopy : card.dataset.oneTimeSubcopy;
  const purchaseLabel = isSubscription ? "Subscribe & Save" : "One-Time Purchase";
  const delivery = isSubscription ? card.dataset.delivery : "One-time purchase";

  form.querySelectorAll(".purchase-option").forEach((option) => {
    const input = option.querySelector('input[name="purchase_option"]');
    option.classList.toggle("selected", input?.checked);
  });

  form.querySelectorAll(".offer-card").forEach((item) => {
    const input = item.querySelector('input[name="id"]');
    item.classList.toggle("selected", item === card);
    if (input) input.checked = item === card;
    const itemPrice = Number(isSubscription ? item.dataset.subscriptionPrice : item.dataset.oneTimePrice);
    const itemCompare = Number(item.dataset.compareAt);
    const itemSubcopy = isSubscription ? item.dataset.subscriptionSubcopy : item.dataset.oneTimeSubcopy;
    const priceNode = item.querySelector("[data-sc-card-price]");
    const compareNode = item.querySelector("[data-sc-card-compare]");
    const subcopyNode = item.querySelector("[data-sc-card-subcopy]");
    const savingsNode = item.querySelector("[data-sc-card-savings]");
    const savingsCopyNode = item.querySelector("[data-sc-card-savings-copy]");
    const displayedSavingsRate = isSubscription
      ? item.dataset.subscriptionTotalSavingsRate
      : item.dataset.oneTimeSavingsRate;
    if (priceNode) priceNode.textContent = formatCents(itemPrice);
    if (compareNode) compareNode.textContent = formatCents(itemCompare);
    if (subcopyNode) subcopyNode.textContent = itemSubcopy || "";
    if (savingsNode) savingsNode.textContent = `Save ${displayedSavingsRate || 0}%`;
    if (savingsCopyNode) {
      savingsCopyNode.textContent = isSubscription
        ? `Save ${item.dataset.subscriptionSavingsRate || 0}% vs one-time purchase`
        : `Save ${item.dataset.oneTimeSavingsRate || 0}% today`;
    }
  });

  if (sellingPlanInput) {
    sellingPlanInput.disabled = !isSubscription;
    sellingPlanInput.value = isSubscription ? card.dataset.sellingPlanId || "" : "";
  }
  if (currentPrice) currentPrice.textContent = formatCents(cardPrice);
  if (currentCompare) currentCompare.textContent = formatCents(compareAt);
  form.closest(".product-reference")?.classList.toggle("is-one-time", !isSubscription);
  updateStickyOffer(card, isSubscription);
  if (submit && !submit.disabled) {
    submit.textContent = isSubscription
      ? `Add To Cart - Subscribe & Save ${card.dataset.subscriptionSavingsRate || 0}%`
      : "Add To Cart - One-Time Purchase";
  }

  setProperty(form, "purchase_type", purchaseLabel);
  setProperty(form, "boxes", card.dataset.boxLabel || "");
  setProperty(form, "delivery", delivery);
  setProperty(form, "compare_at_unit", String(compareAt || cardPrice));
  setProperty(
    form,
    "savings_rate",
    isSubscription ? card.dataset.subscriptionTotalSavingsRate || "" : card.dataset.oneTimeSavingsRate || "",
  );
};

document.querySelectorAll(".shopify-product-form").forEach((form) => {
  form.addEventListener("change", (event) => {
    const purchaseInput = event.target.closest('input[name="purchase_option"]');
    const variantInput = event.target.closest('input[name="id"]');
    if (purchaseInput) {
      purchaseInput.closest(".purchase-toggle")?.querySelectorAll(".purchase-option").forEach((option) => {
        const input = option.querySelector('input[name="purchase_option"]');
        option.classList.toggle("selected", input?.checked);
      });
    }
    if (variantInput) {
      form.querySelectorAll(".offer-card").forEach((card) => card.classList.toggle("selected", card.contains(variantInput)));
    }
    updateOfferForm(form);
  });
  form.addEventListener("click", (event) => {
    const purchaseOption = event.target.closest(".purchase-option");
    if (purchaseOption) {
      const input = purchaseOption.querySelector('input[name="purchase_option"]');
      if (input) input.checked = true;
    }
    const card = event.target.closest(".offer-card");
    if (card) {
      const input = card.querySelector('input[name="id"]');
      if (input && !input.disabled) input.checked = true;
      form.querySelectorAll(".offer-card").forEach((item) => item.classList.toggle("selected", item === card));
    }
    if (purchaseOption || card) updateOfferForm(form);
  });
  updateOfferForm(form);
});

document.querySelectorAll(".product-accordion-list").forEach((list) => {
  const accordions = Array.from(list.querySelectorAll(".product-accordion"));

  const setOpenAccordion = (selectedAccordion) => {
    accordions.forEach((item) => {
      item.open = item === selectedAccordion;
    });
  };

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector("summary");

    const activateAccordion = (event) => {
      event.preventDefault();
      if (accordion.open) {
        accordion.open = false;
        return;
      }
      setOpenAccordion(accordion);
    };

    if (summary) {
      summary.addEventListener("click", activateAccordion);
      summary.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        activateAccordion(event);
      });
    }

    accordion.addEventListener("toggle", () => {
      if (!accordion.open) return;

      accordions.forEach((item) => {
        if (item !== accordion) item.open = false;
      });
    });
  });
});

document.querySelectorAll(".judgeme-reviews-reference").forEach((section) => {
  const widget = section.querySelector("#judgeme_product_reviews");
  const loadMoreWrap = section.querySelector("[data-judgeme-load-more-wrap]");
  const loadMoreButton = section.querySelector("[data-judgeme-load-more]");
  const loadMoreStatus = section.querySelector("[data-judgeme-load-more-status]");
  if (!widget || !loadMoreWrap || !loadMoreButton || !loadMoreStatus) return;

  let isLoading = false;
  let currentPage = 1;
  let totalReviews = Number(widget.querySelector(".jdgm-rev-widg")?.dataset.numberOfReviews || 0);

  const getReviews = () => Array.from(widget.querySelectorAll(".jdgm-rev-widg__reviews > .jdgm-rev"));

  const updateControls = (announcement = "") => {
    const reviews = getReviews();
    const hasMoreReviews = totalReviews === 0 || reviews.length < totalReviews;

    loadMoreWrap.hidden = reviews.length === 0;
    loadMoreButton.hidden = !hasMoreReviews;
    loadMoreButton.disabled = isLoading;
    loadMoreButton.textContent = isLoading ? "Loading reviews…" : "Load more reviews";

    if (announcement) {
      loadMoreStatus.textContent = announcement;
    } else if (reviews.length > 0) {
      loadMoreStatus.textContent = totalReviews > 0
        ? `Showing ${reviews.length} of ${totalReviews} reviews`
        : `Showing ${reviews.length} reviews`;
    }
  };

  const createElement = (tagName, className = "", text = "") => {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const createReviewElement = (review) => {
    const reviewElement = createElement("div", "jdgm-rev jdgm-divider-top jdgm--done-setup");
    reviewElement.dataset.reviewId = review.uuid || "";
    reviewElement.dataset.productTitle = review.product_title || widget.dataset.productTitle || "";
    reviewElement.dataset.productUrl = review.product_url || "";
    reviewElement.dataset.verifiedBuyer = String(Boolean(review.verified_buyer));

    const header = createElement("div", "jdgm-rev__header");
    header.append(createElement("div", "jdgm-row-product"));

    const ratingRow = createElement("div", "jdgm-row-rating");
    const rating = createElement("span", "jdgm-rev__rating");
    const score = Math.max(0, Math.min(5, Number(review.rating) || 0));
    rating.dataset.score = String(score);
    rating.tabIndex = 0;
    rating.setAttribute("role", "img");
    rating.setAttribute("aria-label", `${score} star review`);
    for (let star = 1; star <= 5; star += 1) {
      rating.append(createElement("span", `jdgm-star ${star <= score ? "jdgm--on" : "jdgm--off"}`));
    }
    ratingRow.append(rating);

    const date = review.created_at ? new Date(review.created_at) : null;
    const dateText = date && !Number.isNaN(date.getTime())
      ? date.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })
      : "";
    const timestamp = createElement("time", "jdgm-rev__timestamp", dateText);
    if (date) timestamp.dateTime = date.toISOString();
    ratingRow.append(timestamp);
    header.append(ratingRow);

    const profileRow = createElement("div", "jdgm-row-profile");
    profileRow.append(createElement("div", "jdgm-rev__icon"));
    const authorWrapper = createElement("span", "jdgm-rev__author-wrapper");
    authorWrapper.append(createElement("span", "jdgm-rev__author", review.reviewer_name || "Anonymous"));
    profileRow.append(authorWrapper);
    header.append(profileRow);
    header.append(createElement("div", "jdgm-row-extra"));
    header.append(createElement("div", "jdgm-rev__br"));
    reviewElement.append(header);

    const content = createElement("div", "jdgm-rev__content");
    if (review.title) content.append(createElement("b", "jdgm-rev__title", review.title));
    const body = createElement("div", "jdgm-rev__body");
    const bodySource = document.createElement("div");
    bodySource.innerHTML = review.body_html || "";
    body.append(createElement("p", "", bodySource.textContent?.trim() || ""));
    content.append(body);

    if (Array.isArray(review.transparency_badges) && review.transparency_badges.includes("review_collected_from_another_provider")) {
      const badgeWrapper = createElement("div", "jdgm-rev__transparency-badge-wrapper");
      badgeWrapper.append(createElement("div", "jdgm-rev__transparency-badge", "Review collected from another provider"));
      content.append(badgeWrapper);
    }

    reviewElement.append(content);
    reviewElement.append(createElement("div", "jdgm-rev__actions"));
    return reviewElement;
  };

  const pagination = widget.querySelector(".jdgm-paginate");
  const reviewsPerPage = Math.max(1, Number(pagination?.dataset.perPage || 5));
  const apiUrl = pagination?.dataset.url || "https://api.judge.me/reviews/reviews_for_widget";
  const productId = widget.dataset.id;
  const shopDomain = widget.dataset.shopDomain || window.Shopify?.shop || window.location.hostname;

  updateControls();

  loadMoreButton.addEventListener("click", async () => {
    if (isLoading || !productId) return;
    isLoading = true;
    updateControls();

    try {
      const params = new URLSearchParams({
        url: shopDomain,
        shop_domain: shopDomain,
        platform: "shopify",
        product_id: productId,
        page: String(currentPage + 1),
        per_page: String(reviewsPerPage)
      });
      const response = await fetch(`${apiUrl}?${params.toString()}`, {
        headers: { Accept: "application/json" }
      });
      if (!response.ok) throw new Error("Judge.me reviews request failed");

      const data = await response.json();
      const reviewList = widget.querySelector(".jdgm-rev-widg__reviews");
      const existingIds = new Set(getReviews().map((review) => review.dataset.reviewId).filter(Boolean));
      const newReviews = Array.isArray(data.reviews)
        ? data.reviews.filter((review) => review.uuid && !existingIds.has(review.uuid))
        : [];
      if (!reviewList || newReviews.length === 0) throw new Error("No additional Judge.me reviews returned");

      newReviews.forEach((review) => reviewList.append(createReviewElement(review)));
      currentPage += 1;
      totalReviews = Number(data.number_of_reviews || totalReviews);
      isLoading = false;
      updateControls(`Loaded ${newReviews.length} more reviews. Showing ${getReviews().length} of ${totalReviews}.`);
    } catch (error) {
      isLoading = false;
      updateControls("Reviews could not be loaded. Please try again.");
    }
  });
});

document.querySelectorAll(".sc-menu").forEach((menu) => {
  menu.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = document.querySelector(link.getAttribute("href"));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      menu.open = false;
    });
  });
});

document.addEventListener("click", (event) => {
  document.querySelectorAll(".sc-menu[open]").forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  document.querySelectorAll(".sc-menu[open]").forEach((menu) => {
    menu.open = false;
  });
});

document.addEventListener("click", (event) => {
  if (event.defaultPrevented) return;
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute("href"));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
});

const stickyCta = document.querySelector(".sticky-cta");
const stickyTarget = stickyCta ? document.querySelector(stickyCta.getAttribute("href")) : null;
const updateSticky = () => {
  if (!stickyCta) return;
  const targetRect = stickyTarget ? stickyTarget.getBoundingClientRect() : null;
  const targetIsVisible = targetRect ? targetRect.top < window.innerHeight && targetRect.bottom > 0 : false;
  document.body.classList.toggle("show-sticky", window.scrollY > 900 && !targetIsVisible);
};
window.addEventListener("scroll", updateSticky, { passive: true });
window.addEventListener("resize", updateSticky);
updateSticky();
